import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import Sketch from "@uiw/react-color-sketch";
import { setWeatherTextColor } from "../../../redux/Slices/Apps/appsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const CornerAreaControl = ({ area, xs = false, setArea }) => {
    const { t } = useTranslation();
    const { control, setValue } = useForm();
    const { weatherTextColor } = useSelector(state => state.apps);
    const dispatch = useDispatch()
    const [displayColorPicker, setDisplayColorPicker] = useState({
        text: false,
    });


    useEffect(() => {
        if (area) {
            setValue("start_margin", area.start_margin);
            setValue("top_margin", area.top_margin);
            setValue("width", area.width);
            setValue("height", area.height);
        }
    }, [area, setValue]);

    const handleChange = (field, value) => {
        const safeValue = Math.max(0, Math.min(100, parseFloat(value) || 0));
        setArea({ ...area, [field]: safeValue });
    };

    const colorPickerHandler = (key) => {
        setDisplayColorPicker(prev => ({ ...prev, [key]: !prev[key] }))
    }

    return (
        <div className=" rounded w-100    mt-4">

            <div className="border-top text-center  py-2">{t('weather.corner_settings')}</div>

            {xs ?
                <>
                    <div className="">

                        {/* {window.location.pathname.includes("weather") && ( */}
                            <div className="w-50">
                                <label className={`block text-sm mb-1`}>{t('weather.text_color')}</label>
                                <div className="border-1 p-2 rounded d-flex position-relative">
                                    <Sketch
                                        color={weatherTextColor}
                                        disableAlpha={false}
                                        onChange={(color) => {
                                            dispatch(setWeatherTextColor(color.hexa))
                                        }}
                                        onMouseLeave={() => colorPickerHandler("text")}
                                        className={`right-[0] position-absolute color_picker ${displayColorPicker.text ? "d-block" : "d-none"}`}
                                    />
                                    <div className='me-3 cursor-pointer border-1'
                                        onClick={() => colorPickerHandler("text")}
                                        style={{ backgroundColor: `${weatherTextColor}`, width: "25px", height: "25px" }} >
                                    </div>
                                    <div className='border-bottom' >{weatherTextColor}</div>
                                </div>
                            </div>
                        {/* )} */}



                        <div className="flex gap-2">

                            <div className="w-50">
                                <label className="block text-sm mb-1">{t('weather.x_percent')}</label>
                                <Controller
                                    name="start_margin"
                                    control={control}
                                    render={({ field }) => (
                                        <InputNumber
                                            {...field}
                                            min={0}
                                            max={100}
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                handleChange("start_margin", e.value);
                                            }}
                                        />
                                    )}
                                />
                            </div>

                            <div className="w-50">
                                <label className="block text-sm mb-1">{t('weather.y_percent')}</label>
                                <Controller
                                    name="top_margin"
                                    control={control}
                                    render={({ field }) => (
                                        <InputNumber
                                            {...field}
                                            min={0}
                                            max={100}
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                handleChange("top_margin", e.value);
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className="flex gap-2">

                            <div>
                                <label className="block text-sm mb-1">{t('weather.width_percent')}</label>
                                <Controller
                                    name="width"
                                    control={control}
                                    render={({ field }) => (
                                        <InputNumber
                                            {...field}
                                            min={0}
                                            max={100}
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                handleChange("width", e.value);
                                            }}
                                        />
                                    )}
                                />
                            </div>

                            <div>
                                <label className="block text-sm mb-1">{t('weather.height_percent')}</label>
                                <Controller
                                    name="height"
                                    control={control}
                                    render={({ field }) => (
                                        <InputNumber
                                            {...field}
                                            min={0}
                                            max={100}
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                handleChange("height", e.value);
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>

                </>
                :
                <>
                    <div className="flex gap-3">

                        {/* {window.location.pathname.includes("weather") && ( */}
                            <div>
                                <label className={`block text-sm mb-1`}>{t('weather.text_color')}</label>
                                <div className="border-1 p-2 rounded d-flex position-relative">
                                    <Sketch
                                        color={weatherTextColor}
                                        disableAlpha={false}
                                        onChange={(color) => {
                                            dispatch(setWeatherTextColor(color.hexa))
                                        }}
                                        onMouseLeave={() => colorPickerHandler("text")}
                                        className={`right-[0] position-absolute color_picker ${displayColorPicker.text ? "d-block" : "d-none"}`}
                                    />
                                    <div className='me-3 cursor-pointer border-1'
                                        onClick={() => colorPickerHandler("text")}
                                        style={{ backgroundColor: `${weatherTextColor}`, width: "25px", height: "25px" }} >
                                    </div>
                                    <div className='border-bottom' >{weatherTextColor}</div>
                                </div>
                            </div>
                        {/* ) */}
                        {/* } */}




                        <div>
                            <label className="block text-sm mb-1">{t('weather.x_percent')}</label>
                            <Controller
                                name="start_margin"
                                control={control}
                                render={({ field }) => (
                                    <InputNumber
                                        {...field}
                                        min={0}
                                        max={100}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                            handleChange("start_margin", e.value);
                                        }}
                                    />
                                )}
                            />
                        </div>

                        <div>
                            <label className="block text-sm mb-1">{t('weather.y_percent')}</label>
                            <Controller
                                name="top_margin"
                                control={control}
                                render={({ field }) => (
                                    <InputNumber
                                        {...field}
                                        min={0}
                                        max={100}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                            handleChange("top_margin", e.value);
                                        }}
                                    />
                                )}
                            />
                        </div>

                        <div>
                            <label className="block text-sm mb-1">{t('weather.width_percent')}</label>
                            <Controller
                                name="width"
                                control={control}
                                render={({ field }) => (
                                    <InputNumber
                                        {...field}
                                        min={0}
                                        max={100}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                            handleChange("width", e.value);
                                        }}
                                    />
                                )}
                            />
                        </div>

                        <div>
                            <label className="block text-sm mb-1">{t('weather.height_percent')}</label>
                            <Controller
                                name="height"
                                control={control}
                                render={({ field }) => (
                                    <InputNumber
                                        {...field}
                                        min={0}
                                        max={100}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                            handleChange("height", e.value);
                                        }}
                                    />
                                )}
                            />
                        </div>
                    </div>

                </>
            }

        </div>
    );
};

export default CornerAreaControl;
